
import CardNoticias from './cardNoticias';
import 'swiper/css';
import 'swiper/css/pagination';
import HeaderSession from '../../../utils/headerSession';
import { useEffect, useState } from 'react';
import api from '../../../services/api';
import Loading from '../../../load/loading';
import RegisterAccess from '../../../utils/registerAccess';

export default function PageNoticias() {
  const [noticias, setNoticias] = useState('')

  useEffect(() => {
    api.get(`/noticias`)
      .then(response => {
        // console.log(response)
        setNoticias(response.data.noticias);
      }).catch(error => {
        // console.log(error)
      })
  }, [])



  return (
    <div className="tw-mx-auto tw-max-w-[800px] tw-min-h-[70vh] tw-px-4">
     <RegisterAccess page={'noticias'} />
      <HeaderSession title='NOTÍCIAS' />

      <div className="tw-mt-4 tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-gap-6">
        {noticias ?
          noticias.map((noticia) => (
            noticia.status === "Activo" &&
            <CardNoticias key={noticia._id} noticia={noticia} />
          ))
          :
          <Loading />
        }
      </div>
      <div className="tw-h-8" />
    </div>
  )
}